import { apiHelper, PromiseHandler } from "../redux/apiHelper";

export const getRoles = () => PromiseHandler(apiHelper('get', '/api/admin/role/list'))
export const addRole = (role) => PromiseHandler(apiHelper('post', '/api/admin/role/create', role))
export const updateRole = (role) => PromiseHandler(apiHelper('post', '/api/admin/role/edit', role))
export const deleteRole = (id) => PromiseHandler(apiHelper('post', `/api/admin/role/delete/${id}`))